'use strict';

import EmployeeBaseRouter from './Base.js';
import DashboardLayoutView from '../views/dashboard/Layout.js';
import LeaveTypes from 'newCollections/leave-types.js';
import ActionLogs from 'newCollections/action-logs.js';
import LeaveApprovals from 'newCollections/leave-approvals.js';

module.exports = EmployeeBaseRouter.extend({
    routes: {
        'dashboard': 'dashboard'
    },

    titles: {
        'dashboard': 'Dashboard'
    },

    dashboard: function() {
        this.layout = new DashboardLayoutView({el: this.el});

        const approvals = new LeaveApprovals(null, {
            approver: app.employee,
            pagination: false
        });
        const leaveTypes = new LeaveTypes(null, {company: app.company});
        return leaveTypes.fetch().then(() => Promise.all([
            new ActionLogs().fetchForEmployee(app.employee),
            leaveTypes.fetchBalances(app.employee),
            LeaveTypes.fetchCarryForwardDays(app.employee),
            approvals.fetch({filter: {limit: 9999}})
        ]))
        .then(([actionLogs, types, counters, cfDays]) => {
            this.layout.renderLeave({
                leaveTypes: types,
                carryForwardDays: cfDays
            });

            let layerMap = {};
            approvals.forEach(approval => {
                layerMap[approval.get('requesterId')] =
                    approval.get('layer');
            });
            layerMap[app.employee.id] = 0;
            this.layout.renderActionLog({
                collection: actionLogs,
                fetchMore: options => new ActionLogs().fetchForEmployee(
                    app.employee, options
                ),
                layerMap
            });

            if (!app.employee.get('isSetUp')) {
                this.layout.renderDefault({company: app.company});
            }
        });
    }
});



// WEBPACK FOOTER //
// ./app/employee/routers/Dashboard.js